<form [formGroup]="form">
  <h3-attribute-display-label
    [attribute]="attribute"
    [annotationStore]="annotationStore"
    [attributeValue]="attributeValue$ | async"
    [ngClass]="{ clickable: (isReadOnly$ | async) === false }"
    (click)="focusIn()"
    *ngIf="!isFocused"
  >
    <div class="subtitle-03 attribute-value">
      {{ (attributeLabel$ | async) || '-' }}
    </div>
  </h3-attribute-display-label>

  <div
    class="input-container"
    *ngIf="isFocused"
    #inputContainer
    (focusout)="focusOut()"
  >
    <div class="caption">
      <span>{{ attribute.name }}</span>
      <mat-icon (click)="clearValue()" tabindex="1">refresh</mat-icon>
    </div>
    <mat-form-field subscriptSizing="dynamic">
      <textarea
        matInput
        formControlName="input"
        #inputArea
        tabindex="1"
        (keydown)="onKeyPress($event)"
      ></textarea>
    </mat-form-field>
  </div>
</form>
